var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificationYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5449 21.2115C21.802 21.2112 22.0544 21.1428 22.2766 21.0134C22.4987 20.884 22.6826 20.698 22.8097 20.4745C22.9367 20.251 23.0024 19.9978 22.9999 19.7407C22.9975 19.4837 22.9271 19.2318 22.7958 19.0107L12.7503 2.14756C12.6211 1.93108 12.4378 1.75185 12.2186 1.62739C11.9993 1.50293 11.7515 1.4375 11.4994 1.4375C11.2472 1.4375 10.9994 1.50293 10.7801 1.62739C10.5609 1.75185 10.3777 1.93108 10.2484 2.14756L0.204179 19.0107C0.0729206 19.2318 0.00249887 19.4837 6.52863e-05 19.7407C-0.00236829 19.9978 0.0632726 20.251 0.190323 20.4745C0.317373 20.698 0.501308 20.884 0.723451 21.0134C0.945594 21.1428 1.19803 21.2112 1.45514 21.2115H21.5449Z",
    fill: "#FFCF54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7338 12.8212V8.55893C12.7338 8.23156 12.6038 7.9176 12.3723 7.68612C12.1408 7.45463 11.8268 7.32458 11.4995 7.32458C11.1721 7.32458 10.8582 7.45463 10.6267 7.68612C10.3952 7.9176 10.2651 8.23156 10.2651 8.55893V12.8212C10.2651 13.1486 10.3952 13.4626 10.6267 13.6941C10.8582 13.9255 11.1721 14.0556 11.4995 14.0556C11.8268 14.0556 12.1408 13.9255 12.3723 13.6941C12.6038 13.4626 12.7338 13.1486 12.7338 12.8212Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6914 18.3431C12.3643 18.234 12.8213 17.6002 12.7122 16.9273C12.6031 16.2545 11.9693 15.7974 11.2964 15.9065C10.6236 16.0156 10.1665 16.6495 10.2756 17.3223C10.3847 17.9951 11.0186 18.4522 11.6914 18.3431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationYellow);
export default __webpack_public_path__ + "static/media/icon-notification-yellow.c020201d53afd3edcc0b3187ae6e452d.svg";
export { ForwardRef as ReactComponent };